export const BASE_URL = process.env.APPLICATION_URL || "http://localhost:3000";
export const API_URL = BASE_URL + "/api/v1";
export const BUBBLE_BASE_URL =
  process.env.BUBBLE_BASE_URL ||
  "https://multiply-partner-portal.bubbleapps.io/version-test";
export const BUBBLE_API_URL = BUBBLE_BASE_URL + "/api/1.1/obj";
export const STATUS_APPLICATION_FOR_APPROVAL = 0;
export const STATUS_APPLICATION_PENDING = 1;
export const STATUS_APPLICATION_REJECTED = 2;
